import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { recordarMarcaDeUrl } from './utils/marcaClic';

// SF-145: guarda fbclid/gclid de la URL de entrada por si el visitante navega
// antes de cotizar (la URL de la página donde cotiza ya no los trae).
recordarMarcaDeUrl();

const mountWidget = () => {
  const widgetContainer = document.getElementById('cotizador-viajes');
  if (widgetContainer) {
    const root = ReactDOM.createRoot(widgetContainer);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
};

// Montar el widget cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountWidget);
} else {
  mountWidget();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
